import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import api, { getRole } from '../../utils/authUtils';

const ProtectedSpeakerRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await api.get('/api/protected');
        const role = getRole();
        setAuthStatus(role === 'SPEAKER' || role === 'ADMIN' ? 'authenticated' : 'unauthenticated');
      } catch (error) {
        if (error.message === 'Session expired. Please login again.') {
          navigate('/speaker/login?session_expired=true', { replace: true });
        } else {
          setAuthStatus('unauthenticated');
        }
      }
    };

    checkAuth();
  }, [navigate]);

  if (authStatus === 'checking') {
    return <div>Loading...</div>;
  }

  if (authStatus === 'unauthenticated') {
    return <Navigate to="/speaker/login" replace />;
  }

  return children;
};

export default ProtectedSpeakerRoute;
